export const environment = {
  production: false,
  environmentName: 'development',
  enabledServiceWorker: true,
  cargamos: {
    apiUrl: 'https://dev.services.shippers.cargamos.com',
    apiKey: 'AIzaSyBXw94azOUzt0H9ixI6q9HsN_kyHEzVyKc',
  },
};
